import { Environment } from '@amzn/aws-d2c-visitor-id-client';

// https://issues.amazon.com/issues/P84086944
const BASEURL_MAP: Record<Environment, string> = {
  [Environment.DEV]: 'https://alpha.d2c.marketing.aws.dev',
  [Environment.ALPHA]: 'https://alpha.d2c.marketing.aws.dev',
  [Environment.BETA]: 'https://beta.d2c.marketing.aws.dev',
  [Environment.GAMMA]: 'https://gamma.d2c.marketing.aws.dev',
  [Environment.PROD]: 'https://d2c.aws.amazon.com',
  [Environment.INT_TEST]: 'https://d2c.aws.amazon.com',
};

const BASEURL_MAP_CN: Record<Environment, string> = {
  [Environment.DEV]: 'https://alpha.d2c.marketing.aws.a2z.org.cn',
  [Environment.ALPHA]: 'https://alpha.d2c.marketing.aws.a2z.org.cn',
  [Environment.BETA]: 'https://beta.d2c.marketing.aws.a2z.org.cn',
  [Environment.GAMMA]: 'https://gamma.d2c.marketing.aws.a2z.org.cn',
  [Environment.PROD]: 'https://d2c.amazonaws.cn',
  [Environment.INT_TEST]: 'https://alpha.d2c.marketing.aws.a2z.org.cn',
};

/**
 * Determines if the website is a china site or not using the top level domain (.com or .in vs .cn)
 */
export function isChinaRegion() {
  return window.location.hostname.endsWith('.cn');
}

/**
 * Determines the base URL (not including path) based on the environment string
 * @returns the base URL to use for API calls
 */
export function getD2CBaseURL() {
  const env = getD2CClientEnv();

  if (isChinaRegion()) {
    return BASEURL_MAP_CN[env];
  }

  return BASEURL_MAP[env];
}

/**
 * Returns the environment stage the D2C client is currently running on, used to determine the respective endpoints for dependent services.
 * Defaults to prod if window.AWSMA.ENV is not set. window.AWSMA.ENV is set by the Client Loader script.
 * @returns - Environment D2C Client is executing in. Determines endpoints for Visitor Service and D2C.
 */
export function getD2CClientEnv(): Environment {
  try {
    return window.AWSMA.ENV ?? Environment.PROD;
  } catch {
    return Environment.PROD;
  }
}
